module.exports = __webpack_public_path__ + "2d5fcee0010800bdea27ddfaf660f77c.png";